<template>
  <div class="app-container">
    <!-- PC端 start -->
    <div v-if="isMobile === false">
      <el-card class="box-card" style="width: 80%; margin: 10px auto; margin-top: 30px;">
        <div style="margin-top: 20px; text-align: center;">
          <img :src="origin_shop_logo_url + '?imageView2/0/w/360/h/180/q/75|imageslim'" style="width: 200px;">
          <p style="font-size: 24px;">
            <span>{{ origin_shop_name }}</span>
            — 代理商自助申请</p>
        </div>
      </el-card>
      <el-card class="box-card" style="width: 80%; margin: 20px auto;">
        <div slot="header" class="clearfix">
          <span style="font-size: 18px;">申请信息</span>
        </div>

        <el-form :model="agentForm" :rules="rules" label-width="180px" ref="ruleForm" style="width: 85%;">
          <p style="padding-left: 180px; font-size: 14px; color: red;">* 为必填项</p>
          <el-form-item label="登录账号" prop="shop_admin_email">
            <el-input
              v-model="agentForm.shop_admin_email"
              placeholder="最少6位英文字母或数字"
            ></el-input>
          </el-form-item>
          <el-form-item label="初始密码" prop="shop_admin_password">
            <el-input
              v-model="agentForm.shop_admin_password"
              placeholder="初始密码"
              show-password="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="店铺名字" prop="display_shop_name">
            <el-input
              v-model="agentForm.display_shop_name"
              placeholder="店铺名字"
            ></el-input>
          </el-form-item>
          <el-form-item label="店铺Logo">
            <el-select
              v-model="agentForm.shop_logo_qiniu_res_key"
              placeholder="请选择Logo"
              style="width: 260px; margin-bottom: 20px;"
              v-if="!agentForm.shop_logo_url"
              clearable
            >
              <el-option
                v-for="logo in logos"
                :key="logo.key"
                :label="logo.name"
                :value="logo.key"
                style="height: 70px; padding: 5px 20px; display: flex; align-items: center;"
              >
                <img class="avatar" :src="logo.src" style="height:60px">
                <span style="height: 35px; margin-left: 20px;">{{ logo.name }}</span>
              </el-option>
            </el-select>
            <span v-if="!agentForm.shop_logo_url" style="margin-left: 10px; color: #606266;">请选择默认Logo，或自行上传</span>
            <el-upload
              action="https://upload-z2.qiniup.com"
              :limit="2"
              :drag="true"
              :file-list="fileList"
              :on-change="handleChange"
              :http-request="compressImg"
              :on-success="handleAvatarSuccess"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              :data="qiniuData"
              v-loading="imgLoading"
              element-loading-text="图片上传中"
            >
              <img v-if="agentForm.shop_logo_url" :src="displayLogoUrl" class="avatar">
              <div>
                <i class="el-icon-upload" />
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>上传文件</em>
                </div>
              </div>
              <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，长宽尺寸比例为1:1，且不超过2mb</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="联系人" prop="merchant_name">
            <el-input
              v-model="agentForm.merchant_name"
              placeholder="联系人"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="merchant_contact_phone">
            <el-input
              v-model="agentForm.merchant_contact_phone"
              placeholder="联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱" prop="merchant_contact_email">
            <el-input
              v-model="agentForm.merchant_contact_email"
              placeholder="联系邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="merchant_address">
            <el-input
              v-model="agentForm.merchant_address"
              placeholder="联系地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系微信" prop="wechat_id">
            <el-input
              v-model="agentForm.wechat_id"
              placeholder="联系微信"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="代理平台使用协议">
            <el-checkbox v-model="policy">同意</el-checkbox>
            <el-tag style="margin-left: 10px; font-size: 12px;">《代理平台使用协议》</el-tag>
          </el-form-item> -->
          <el-form-item style="margin-top: 50px;">
            <el-button
              type="primary"
              @click="createAgent"
              class="btn"
            >立即注册</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <!-- PC端 end -->

    <!-- 手机端 start -->
    <div v-else>
      <el-card class="box-card" style="width: 95%; margin: 10px auto; margin-top: 30px;">
        <div style="margin-top: 20px; text-align: center;">
          <img :src="origin_shop_logo_url + '?imageView2/0/w/360/h/180/q/75|imageslim'" style="width: 130px;">
          <p style="font-size: 16px;">
            <span>{{ origin_shop_name }}</span>
            — 代理商自助申请</p>
        </div>
      </el-card>
      <el-card class="box-card" style="width: 95%; margin: 20px auto;">
        <div slot="header" class="clearfix">
          <span style="font-size: 16px;">申请信息</span>
        </div>

        <el-form :model="agentForm" :rules="rules" label-width="80px" ref="ruleForm" style="width: 100%;">
          <p style="padding-left: 80px; font-size: 14px; color: red;">* 为必填项</p>
          <el-form-item label="登录账号" prop="shop_admin_email">
            <el-input
              v-model="agentForm.shop_admin_email"
              placeholder="最少6位英文字母或数字"
            ></el-input>
          </el-form-item>
          <el-form-item label="初始密码" prop="shop_admin_password">
            <el-input
              v-model="agentForm.shop_admin_password"
              placeholder="初始密码"
              show-password="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="店铺名字" prop="display_shop_name">
            <el-input
              v-model="agentForm.display_shop_name"
              placeholder="店铺名字"
            ></el-input>
          </el-form-item>
          <el-form-item label="店铺Logo">
            <el-select
              v-model="agentForm.shop_logo_qiniu_res_key"
              placeholder="请选择Logo"
              v-if="!agentForm.shop_logo_url"
              clearable
              style="margin-bottom: 10px;"
            >
              <el-option
                v-for="logo in logos"
                :key="logo.key"
                :label="logo.name"
                :value="logo.key"
                style="height: 70px; padding: 5px 20px; display: flex; align-items: center;"
              >
                <img class="avatar" :src="logo.src" style="height:60px">
                <span style="height: 35px; margin-left: 20px;">{{ logo.name }}</span>
              </el-option>
            </el-select>
            <div v-if="!agentForm.shop_logo_url" style="color: #606266;">请选择默认Logo，或自行上传</div>
            <el-upload
              action="https://upload-z2.qiniup.com"
              :limit="2"
              :drag="true"
              :file-list="fileList"
              :on-change="handleChange"
              :http-request="compressImg"
              :on-success="handleAvatarSuccess"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              :data="qiniuData"
              v-loading="imgLoading"
              element-loading-text="图片上传中"
            >
              <img v-if="agentForm.shop_logo_url" :src="displayLogoUrl" class="avatar">
              <div>
                <i class="el-icon-upload" />
                <div class="el-upload__text" style="font-size: 13px;">
                  将文件拖到此处，或
                  <em>上传文件</em>
                </div>
              </div>
              <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，长宽尺寸比例为1:1，且不超过2mb</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="联系人" prop="merchant_name">
            <el-input
              v-model="agentForm.merchant_name"
              placeholder="联系人"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="merchant_contact_phone">
            <el-input
              v-model="agentForm.merchant_contact_phone"
              placeholder="联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱" prop="merchant_contact_email">
            <el-input
              v-model="agentForm.merchant_contact_email"
              placeholder="联系邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="merchant_address">
            <el-input
              v-model="agentForm.merchant_address"
              placeholder="联系地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系微信" prop="wechat_id">
            <el-input
              v-model="agentForm.wechat_id"
              placeholder="联系微信"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 50px;">
            <el-button
              type="primary"
              @click="createAgent"
              class="btn"
            >立即注册</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <!-- 手机端 end -->

    <el-dialog title="注册代理商成功" :visible.sync="applicationSuccessVisible" width="40%" v-if="isMobile === false">
      <div style="padding: 0 30px;">
        <i class="el-icon-success" style="color: #67C23A; font-size: 28px;" />
        <span style="color: #67C23A; font-size: 28px;">恭喜注册成功！</span>
      </div>
      <div style="padding: 30px; font-size: 18px; line-height: 36px;">
        <div style="">登录链接：
          <a :href="agentAdminUrl" target="_blank" style="text-decoration:underline; color: #409EFF;">
            {{ agentAdminUrl }}
          </a>
        </div>
        <div>登录账号：
          <span style="color: #409EFF;">{{ username }}</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="注册代理商成功" :visible.sync="applicationSuccessVisible" width="90%" v-else>
      <div style="padding: 0 30px;">
        <i class="el-icon-success" style="color: #67C23A; font-size: 22px;" />
        <span style="color: #67C23A; font-size: 22px;">恭喜注册成功！</span>
      </div>
      <div style="padding: 20px 30px; font-size: 16px; line-height: 36px;">
        <div>登录链接：
          <a :href="agentAdminUrl" target="_blank" style="text-decoration:underline; color: #409EFF;">
            {{ agentAdminUrl }}
          </a>
        </div>
        <div>登录账号：
          <span style="color: #409EFF;">{{ username }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import compressor from '@/utils/compressor'
import axios from 'axios'
import { Base64 } from 'js-base64'

export default {
  name: 'Application',
  data() {
    return {
      agentAdminUrl: process.env.VUE_APP_AGENT_URL,
      isMobile: false,
      agentForm: {
        shop_logo_url: '',
        shop_admin_email: '',
        shop_admin_password: '',
        display_shop_name: '',
        agent_level: '',
        shop_logo_qiniu_res_key: '',
        merchant_name: '',
        merchant_contact_phone: '',
        merchant_contact_email: '',
        merchant_address: '',
        wechat_id: '',
        shop_id: ''
      },
      username: '',
      origin_shop_id: '',
      origin_shop_name: '',
      origin_shop_logo_url: '',
      // policy: true,
      fileList: [],
      qiniuData: {
        token: ''
      },
      imgLoading: false,
      applicationSuccessVisible: false,
      logos: [
        {
          name: 'Logo 1',
          key: 'FhLxDCp4fdJurFR3RUpunY3uDr0s',
          src: 'https://img.nzmai.com.cn/FhLxDCp4fdJurFR3RUpunY3uDr0s?imageView2/0/w/100/h/100/q/75|imageslim'
        },
        {
          name: 'Logo 2',
          key: 'FsHj__rdLITKsTyhdmdrWF2G04ke',
          src: 'https://img.nzmai.com.cn/FsHj__rdLITKsTyhdmdrWF2G04ke?imageView2/0/w/100/h/100/q/75|imageslim'
        },
        {
          name: 'Logo 3',
          key: 'FoeXAno3tPcNnRy617kMfhbA-Z7H',
          src: 'https://img.nzmai.com.cn/FoeXAno3tPcNnRy617kMfhbA-Z7H?imageView2/0/w/100/h/100/q/75|imageslim'
        },
        {
          name: 'Logo 4',
          key: 'FsRhq0JL5sh4nJQeChFqNXqYP9Gn',
          src: 'https://img.nzmai.com.cn/FsRhq0JL5sh4nJQeChFqNXqYP9Gn?imageView2/0/w/100/h/100/q/75|imageslim'
        },
        {
          name: 'Logo 5',
          key: 'Fh7JcWRxumSvircC5Tvzh0xLXACa',
          src: 'https://img.nzmai.com.cn/Fh7JcWRxumSvircC5Tvzh0xLXACa?imageView2/0/w/100/h/100/q/75|imageslim'
        },
        {
          name: 'Logo 6',
          key: 'FvoqoStIk9XqMagRWUYNRGNpGl9F',
          src: 'https://img.nzmai.com.cn/FvoqoStIk9XqMagRWUYNRGNpGl9F?imageView2/0/w/100/h/100/q/75|imageslim'
        }
      ],
      rules: {
        shop_admin_email: [
          {
            required: true,
            min: 6,
            message: '请输入账号',
            trigger: 'blur'
          }
        ],
        shop_admin_password: [
          {
            required: true,
            message: '请输入初始密码',
            trigger: 'blur'
          }
        ],
        display_shop_name: [
          {
            required: true,
            message: '请输入店铺名字',
            trigger: 'blur'
          }
        ],
        merchant_name: [
          {
            required: true,
            message: '请输入联系人名字',
            trigger: 'blur'
          }
        ],
        merchant_contact_phone: [
          {
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          }
        ],
        merchant_contact_email: [
          {
            required: true,
            message: '请输入联系邮箱',
            trigger: 'blur'
          }
        ],
        merchant_address: [
          {
            required: true,
            message: '请输入代理商地址',
            trigger: 'blur'
          }
        ],
        wechat_id: [
          {
            required: true,
            message: '请输入联系人微信',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    displayLogoUrl() {
      return (
        this.agentForm.shop_logo_url +
        '?imageView2/0/w/360/h/180/q/75|imageslim'
      )
    }
  },
  created() {
    var fromBase64 = document.location.toString().split('application')
    var origin_shop_id = Base64.decode(decodeURIComponent(fromBase64[1]))
    if (!origin_shop_id) {
      this.$router.push({
        name: '404'
      })
    }
    this.fetchOriginShopInfo()
    this.checkMobile()
    this.fetchUploadToken()
  },
  methods: {
    checkMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isMobile = true
      }
    },
    fetchUploadToken() {
      request({
        url: '/upload-token',
        method: 'get'
      })
        .then(res => {
          this.qiniuData.token = res.data['token']
          console.log(this.qiniuData)
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleError(res) {
      console.log(res)
    },
    handleAvatarSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      console.log(res)
      this.agentForm.shop_logo_qiniu_res_key = res.key
      this.agentForm.shop_logo_url = 'https://img.nzmai.com.cn/' + res.key
      console.log(res)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    compressImg(item) {
      this.imgLoading = true
      compressor.image(item.file)
        .then(file => {
          // console.log(file)
          const formData = new FormData()
          formData.append('token', this.qiniuData.token)
          formData.append('file', file)

          const axiosInstance = axios.create({})
          axiosInstance({
            url: 'https://upload-z2.qiniup.com',
            method: 'POST',
            data: formData
          }).then(response => {
            console.log(response.data.key)
            this.agentForm.shop_logo_qiniu_res_key = response.data.key
            this.agentForm.shop_logo_url = 'https://img.nzmai.com.cn/' + response.data.key
            this.imgLoading = false
          }).catch(error => {
            console.log(error)
            this.imgLoading = false
          })
        })
    },
    fetchOriginShopInfo() {
      var fromBase64 = document.location.toString().split('?')
      this.origin_shop_id = Base64.decode(decodeURIComponent(fromBase64[1]))

      request({
        url: '/info?shop_id=' + this.origin_shop_id,
        method: 'get'
      })
        .then(response => {
          this.origin_shop_name = response.data.display_shop_name
          this.origin_shop_logo_url = response.data.shop_logo_url
        })
        .catch(error => {
          console.warn(error)
        })
    },
    createAgent() {
      if (this.agentForm.shop_admin_email.length < 6) {
        this.$message({
          message: '登录账号必须大于6位英文字母或数字',
          type: 'warning'
        })
        return
      }

      if (this.agentForm.shop_logo_qiniu_res_key.length === 0) {
        this.$message({
          message: '请选择或上传店铺Logo',
          type: 'warning'
        })
        return
      }
      this.username = this.agentForm.shop_admin_email
      var fromBase64 = document.location.toString().split('?')
      this.origin_shop_id = Base64.decode(decodeURIComponent(fromBase64[1]))
      var data = {
        username: this.agentForm.shop_admin_email,
        shop_admin_email: this.agentForm.shop_admin_email,
        shop_admin_password: this.agentForm.shop_admin_password,
        display_shop_name: this.agentForm.display_shop_name,
        shop_logo_qiniu_res_key: this.agentForm.shop_logo_qiniu_res_key,
        merchant_name: this.agentForm.merchant_name,
        merchant_address: this.agentForm.merchant_address,
        merchant_contact_phone: this.agentForm.merchant_contact_phone,
        merchant_contact_email: this.agentForm.merchant_contact_email,
        wechat_id: this.agentForm.wechat_id,
        shop_id: this.origin_shop_id
      }
      request({
        url: '/agent/selfhelp',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: '代理商注册成功',
              type: 'success'
            })
            this.$router.push({
              name: 'ApplicationSuccess',
              params: {
                originShopLogoUrl: this.origin_shop_logo_url,
                originShopName: this.origin_shop_name,
                username: this.username
              }
            })
          } else if (res.status === 40001) {
            this.$message.error(res.data[Object.keys(res.data)[0]])
          } else {
            this.$message.error(res.error)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('注册失败')
        })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.btn {
  width: 150px;
  height: 50px;
  font-size: 16px;
}
</style>
<style type="text/css">
.app-container {
  background: rgb(217, 236, 255);
  background-size: cover;
}
@media screen and (max-width: 500px) {
  .el-input-group__append {
    padding: 0 2px;
  }
  .el-upload-dragger {
    width: 210px !important;
    height: 160px;
  }
}
</style>
